import moment from 'moment'
import { useEffect, useState } from 'react'
import { Card, Table } from 'react-bootstrap'
import { Link } from 'react-router-dom'
import callAPI from '../../../../helpers/callAPI'
import Affiliate from '../../../../templates/Affiliate/Affiliate'
import Dollars from '../../../../templates/Dollars/Dollars'
import Loading from '../../../../templates/UI/Loading/Loading'
import { colors } from '../../../../theme/variables'
import useCallApi from '../../../../hooks/useCallApi'
const APILogsTable = ({ showSystemMessage }) => {
    let lastWeek = moment().subtract(7, 'days').format('YYYY-MM-DD')
    const { data, dataLoaded, refetch } = useCallApi(`apiLogs?startDate=${lastWeek}`, "GET", {}, [], showSystemMessage)
    return (
        <div className="card mb-3 overflow-auto">
        <div className="card-header d-flex justify-content-between">
            <div className="font-weight-bold float-left">API Error Logs</div>
            <Link to={`/system/api-logs`}>Full Report</Link>
        </div>
        <div className="card-body p-0">
            <table className="table table-striped table-card m-0">
                <thead>
                    <tr className="text-secondary">
                        <th>Source</th>
                        <th>File</th>
                        <th>Message</th>
                        <th>Date</th>
                    </tr>
                </thead>
                <tbody>
                    {dataLoaded ? (
                        data.logslength === 0 ? (
                            <tr>
                                <td colSpan={4}>No stats available </td>
                            </tr>
                        ) : (
                            data.logs.map((item, index) => {
                                if (index > 19) return null
                                return (
                                    <tr key={item.id}>
                                        <td>{item.source}</td>
                                        <td>{item.filename}</td>
                                        <td>{item.message}</td>
                                        <td style={{fontSize: '0.87rem'}}>{moment(item.db_date).utc().format('YYYY-MM-DD HH:mm:ss')}</td>
                                    </tr>
                                )
                            })
                        )
                    ) : (
                        <tr>
                            <td colSpan={4}>
                                <Loading />
                            </td>
                        </tr>
                    )}
                </tbody>
            </table>
        </div>
    </div>
    )
}
export default APILogsTable